import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/chevron down.svg` */
export const ChevronDownIcon = createTripletGlyphIcon('ChevronDownIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.50376 5.30011C2.25991 5.00047 2.30493 4.55988 2.60434 4.31573C2.90404 4.0718 3.34557 4.11671 3.58969 4.41632L8.19223 10.0657L12.452 4.43585C12.6853 4.12787 13.1243 4.06694 13.4325 4.30011C13.7404 4.53336 13.8012 4.97238 13.5682 5.28057L8.84067 11.5286C8.53148 11.9373 7.92127 11.9483 7.59751 11.5511L2.50376 5.30011Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.85292 5.90693C2.60923 5.6073 2.65414 5.16666 2.95351 4.92256C3.25316 4.67861 3.69469 4.72365 3.93886 5.02314L9.18691 11.4655L14.0463 5.04268C14.2795 4.73468 14.7186 4.67393 15.0268 4.90693C15.335 5.14013 15.3955 5.57912 15.1625 5.8874L9.84413 12.9167C9.53047 13.3312 8.91175 13.3421 8.58339 12.9392L2.85292 5.90693Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.87282 7.85601C3.55894 7.4708 3.61673 6.90344 4.00172 6.5894C4.38694 6.27558 4.95333 6.33332 5.26735 6.71831L8.78004 11.0298L12.2927 15.3414L18.7976 6.7437C19.0976 6.34765 19.6621 6.26918 20.0584 6.5689C20.4546 6.86869 20.5327 7.43328 20.2332 7.82964L13.1414 17.2027C12.7361 17.7377 11.9365 17.7523 11.5125 17.232L3.87282 7.85601Z"
        fill="currentColor"
      />
    </svg>
  ),
});
